import { ReloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import './Header.scss';

type HeadersProps = {
  title: string;
  handleNext: () => void;
  handleBack: () => void;
  handleRefresh: () => void;
  isBackHidden?: boolean;
  isNextDisabled?: boolean;
  isLastStep?: boolean;
  onMergeClick?: () => void;
};

export const Header = ({
  title,
  handleNext,
  handleBack,
  handleRefresh,
  isBackHidden = false,
  isNextDisabled = false,
  isLastStep = false,
  onMergeClick,
}: HeadersProps) => {
  return (
    <div className="hotel-migration__header">
      <div className="left-part">
        <Button onClick={handleBack} hidden={isBackHidden}>
          Back
        </Button>
      </div>
      <div className="center-part">{title}</div>
      <div className="right-part">
        {isLastStep ? (
          <Button type="primary" onClick={onMergeClick}>
            Merge
          </Button>
        ) : (
          <>
            <Button onClick={handleRefresh} icon={<ReloadOutlined />}>
              Refresh
            </Button>
            <Button
              onClick={handleNext}
              disabled={isNextDisabled}
              type="primary"
            >
              Next
            </Button>
          </>
        )}
      </div>
    </div>
  );
};
